export default "__VITE_ASSET__DeczdXXX__"